export default {
  title: "Cronograma",
  description: "Planifica los hitos y eventos",
  addItem: "Añadir elemento",
  editItem: "Editar elemento",
  deleteItem: "Eliminar elemento",
  confirmDelete: "¿Eliminar este elemento?",
  categories: {
    ceremony: "Ceremonia",
    reception: "Recepción",
    photos: "Fotos",
    other: "Otro",
    photo: "Fotos",
    preparation: "Preparación",
    task: "Tarea",
    vendor: "Proveedor",
    reminder: "Recordatorio",
    custom: "Personalizado",
    entertainment: "Entretenimiento",
    meal: "Comida",
    transportation: "Transporte",
    select: "Selecciona una categoría",
    religious_venue: "Lugar de culto",
    city_hall: "Ayuntamiento",
    none: "Ninguna"
  },
  examples: {
    preparation: {
      title: "Preparación",
      description: "Preparación de los novios y vestimenta"
    },
    ceremony: {
      title: "Ceremonia",
      description: "Ceremonia civil o religiosa"
    },
    cocktail: {
      title: "Cóctel",
      description: "Vino de honor y fotos"
    },
    lunch: {
      title: "Almuerzo / Cena",
      description: "Comida de boda"
    },
    speeches: {
      title: "Discursos",
      description: "Discursos de los testigos y la familia"
    },
    cake: {
      title: "Pastel",
      description: "Corte del pastel y champán"
    },
    party: {
      title: "Fiesta",
      description: "Baile de apertura y fiesta bailable"
    },
    guestsArrival: {
      title: "Llegada de los invitados",
      description: "Los invitados comienzan a llegar al lugar"
    },
    dancing: {
      title: "Baile",
      description: "La pista de baile está abierta"
    }
  },
  sharing: {
    recipientEmail: "Email del destinatario",
    emailPlaceholder: "ejemplo@email.com",
    recipientName: "Nombre del destinatario",
    namePlaceholder: "Nombre",
    message: "Mensaje",
    messagePlaceholder: "Tu mensaje...",
    send: "Enviar",
    cancel: "Cancelar",
    title: "Compartir cronograma"
  },
  addEvent: "Añadir evento",
  noEvents: "Ningún evento",
  addFirstEvent: "Añade tu primer evento",
  titlePlaceholder: "Nombre del evento",
  descriptionPlaceholder: "Descripción del evento",
  durationLabel: "Duración",
  timelineWidget: {
    title: "Cronología",
    subtitle: "Próximos eventos",
    empty: "Ningún evento próximo"
  },
  filters: {
    category: "Categoría",
    date: "Fecha",
    search: "Buscar un evento",
    clear: "Borrar filtros",
    apply: "Aplicar",
    previous: "Anterior",
    next: "Siguiente"
  },
  status: {
    scheduled: "Planificado",
    confirmed: "Confirmado",
    completed: "Finalizado",
    cancelled: "Cancelado",
    delayed: "Retrasado",
    in_progress: "En progreso"
  },
  participants: "Participantes",
  reminders: "Recordatorios",
  minutesAbbr: "min",
  duration: "Duración",
  errors: {
    noWeddingFound: "No se encontró ninguna boda",
    createWeddingFirst: "Por favor crea una boda primero",
    loadEvents: "Error al cargar los eventos",
    addEvent: "Error al añadir el evento",
    updateEvent: "Error al actualizar el evento",
    deleteEvent: "Error al eliminar el evento",
    addExampleEvents: "Error al añadir los eventos de ejemplo"
  },
  actions: {
    addEvent: "Añadir evento",
    share: "Compartir",
    useExample: "Usar una plantilla",
    addExamples: "Añadir ejemplos",
    addingExamples: "Añadiendo ejemplos..."
  },
  empty: {
    title: "Ningún evento",
    description: "Empieza a planificar tu día añadiendo eventos."
  },
  delete: {
    title: "Eliminar evento",
    confirmation: "¿Seguro que quieres eliminar este evento? Esta acción es irreversible."
  },
  aria: {
    addEvent: "Añadir evento",
    edit: "Editar evento",
    delete: "Eliminar evento"
  },
  form: {
    title: "Detalles del evento",
    name: "Apellido",
    description: "Descripción",
    category: "Categoría",
    startTime: "Hora de inicio",
    endTime: "Hora de finalización",
    location: "Lugar",
    notes: "Notas",
    submit: "Guardar",
    cancel: "Cancelar"
  },
  messages: {
    createSuccess: "Evento añadido exitosamente",
    updateSuccess: "Evento actualizado exitosamente",
    deleteSuccess: "Evento eliminado exitosamente",
    deleteConfirm: "¿Seguro que quieres eliminar este evento?",
    error: "Ocurrió un error"
  },
  modal: {
    title: "Evento",
    edit: "Editar evento",
    delete: "Eliminar evento",
    confirmDelete: "¿Seguro que quieres eliminar este evento?"
  },
  view: {
    day: "Día",
    week: "Semana",
    month: "Mes",
    today: "Hoy",
    daysLeft: "Quedan {{count}} días",
    upcoming: "Próximamente"
  }
};
